module.exports = __webpack_public_path__ + "img/1.3a7cb550.png";